import { useFeatureFlag as useConfigCatFeatureFlag } from "configcat-react";
import { FeatureFlag } from "../enums/feature-flag";
import { useConfigCatUser } from "../contexts/configcat-user-context";

// Like ConfigCat's useFeatureFlag, but with some enhancements:
//
// - Enforces TypeScript typing of our feature flags
//
// - Integrates with React state, so user updates are reflected immediately
//   (importantly, when the app first loads).  "client.setDefaultUser()", which
//   is provided by ConfigCat, does not integrate with React state.
//
// In this app, use this instead of ConfigCat's useFeatureFlag.
const useFeatureFlag = (flag: FeatureFlag, defaultValue = false) => {
    const user = useConfigCatUser();
    return useConfigCatFeatureFlag(flag, defaultValue, user);
};

export default useFeatureFlag;
